import { useEffect, useState } from "react";
import { FormikProvider, useFormik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";

export default function RecipientInstitutes() {
  const [recipientInstData, setRecipientInstData] = useState(false);
  const [closureData, setClosureData] = useState(false);

  // ✅ Common Radio Style
  const radioWrapperStyle = {
    display: "flex",
    justifyContent: "center",
    gap: "12px",
  };

  // ✅ Reusable Radio UI
  const RadioButtons = (name) => (
    <div style={radioWrapperStyle}>
      <label style={{ marginBottom: 0 }}>
        <Field
          type="radio"
          name={name}
          value="YES"
          disabled={recipientInstData}
        />{" "}
        Yes
      </label>

      <label style={{ marginBottom: 0 }}>
        <Field
          type="radio"
          name={name}
          value="NO"
          disabled={recipientInstData}
        />{" "}
        No
      </label>
    </div>
  );

  // ✅ Initial Values
  const initialValues = {
    instCode1: "",
    instName1: "",
    transferredInst1: "",
    supplementInst1: "",
    backlogExamInst1: "",

    instCode2: "",
    instName2: "",
    transferredInst2: "",
    supplementInst2: "",
    backlogExamInst2: "",
  };

  // ✅ Validation
  const validationSchema = Yup.object({
    instName1: Yup.string().required("Required"),
    transferredInst1: Yup.string().required("Required"),
    supplementInst1: Yup.string().required("Required"),
    backlogExamInst1: Yup.string().required("Required"),

     instName2: Yup.string().required("Required"),
    transferredInst2: Yup.string().required("Required"),
    supplementInst2: Yup.string().required("Required"),
    backlogExamInst2: Yup.string().required("Required"),
  });

  // ✅ Formik
  const formik = useFormik({
    initialValues,
    validationSchema,

    onSubmit: (values) => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to submit?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Submit",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            recipientInstitutes: [
              {
                instCode: parseInt(values.instCode1),
                instName: values.instName1,
                transferred: values.transferredInst1,
                supplement: values.supplementInst1,
                backlogExam: values.backlogExamInst1,
              },

              {
                instCode: parseInt(values.instCode2),
                instName: values.instName2,
                transferred: values.transferredInst2,
                supplement: values.supplementInst2,
                backlogExam: values.backlogExamInst2,
              },
            ],
          };

          let url = config.url.FAC_URL + "saveRecipientDetails";

          CommonAxiosPost(url, payload).then((res) => {
            if (res?.data?.scode === "01") {
              Swal.fire("Success", "Saved Successfully", "success").then(() => {
                getRecipientData(values.instCode1, values.instCode2);
              });
            } else {
              Swal.fire("Error", "Failed to Save", "error");
            }
          });
        }
      });
    },
  });

  // ✅ Fetch closure data
  function getInstData() {
    let closureUrl = config.url.FAC_URL + "getClosureData";

    CommonAxiosGet(closureUrl).then((res) => {
      if (res?.data?.scode === "01") {
        setClosureData(true);
        const data = res.data.closureData;

        formik.setFieldValue("instName1", data[0]?.inst1_name || "");
        formik.setFieldValue("instName2", data[0]?.inst2_name || "");
        formik.setFieldValue("instCode1", data[0]?.inst1_code || "");
        formik.setFieldValue("instCode2", data[0]?.inst2_code || "");

        // ✅ Call recipient API AFTER inst codes ready
        getRecipientData(data[0]?.inst1_code, data[0]?.inst2_code);
      }
    });
  }

  // ✅ Fetch RECIPIENT data
  function getRecipientData(instCode1, instCode2) {
    let url = config.url.FAC_URL + "getRecipientDetails";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setRecipientInstData(true);
        const recipientData = res.data.data;
        recipientData.forEach((item) => {
          // Match Inst 1
          if (parseInt(item.inst_code) === parseInt(instCode1)) {
            formik.setFieldValue("transferredInst1", item.transferred || "");
            formik.setFieldValue("supplementInst1", item.supplement || "");
            formik.setFieldValue("backlogExamInst1", item.backlog_exam || "");
          }
          // Match Inst 2
          if (parseInt(item.inst_code) === parseInt(instCode2)) {
            formik.setFieldValue("transferredInst2", item.transferred || "");
            formik.setFieldValue("supplementInst2", item.supplement || "");
            formik.setFieldValue("backlogExamInst2", item.backlog_exam || "");
          }
        });
      }
    });
  }
  useEffect(() => {
    getInstData();
  }, []);

  return (
    <div className="faculty-form-wrapper">
      <div className="faculty-card">
        <h5 className="mb-3 innerheader-new">
          <span>Details of Recipient Institute(s)</span>
        </h5>

        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            {closureData?(<>
             <div className="table-responsive mt-3">
              <table className="table table-bordered">
                <thead className="table-primary">
                  <tr>
                    <th width="2%">S.No</th>
                    <th width="30%">Item</th>
                    <th width="30%">Recipient Institution 1 </th>
                    <th width="30%">Recipient Institution 2 (If any) </th>
                  </tr>
                </thead>

                <tbody>
                  {/* Row 1 */}
                  <tr>
                    <td>1</td>
                    <td>Name of the Institution</td>
                    <td>
                      <Field
                        type="text"
                        name="instName1"
                        className="form-control"
                        disabled={closureData}
                      />
                      <ErrorMessage
                        name="instName1"
                        component="div"
                        className="text-danger"
                      />
                    </td>
                    <td>
                      <Field
                        type="text"
                        name="instName2"
                        className="form-control"
                        disabled={closureData}
                      />
                    </td>
                  </tr>
                  {/* Row 2 */}
                  <tr>
                    <td>2</td>
                    <td>
                      Whether the recipient institute(s) have given an
                      undertaking to take responsibility for the students
                      transferred to their institutes
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {RadioButtons("transferredInst1")}
                      <ErrorMessage
                        name="transferredInst1"
                        component="div"
                        className="text-danger"
                      />
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {RadioButtons("transferredInst2")}
                       <ErrorMessage
                        name="transferredInst2"
                        component="div"
                        className="text-danger"
                      />
                    </td>
                  </tr>
                  {/* Row 3 */}
                  <tr>
                    <td>3</td>
                    <td>
                      Whether the recipient institute(s) have given undertaking
                      to conduct supplementary examinations for the backlog
                      students of closing institute until they exhaust? And also
                      responsibility to collect the marks award sheets and
                      diploma certificates of the backlog students of closing
                      institution until they exhaust?
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {RadioButtons("supplementInst1")}
                      <ErrorMessage
                        name="supplementInst1"
                        component="div"
                        className="text-danger"
                      />
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {RadioButtons("supplementInst2")}
                       <ErrorMessage
                        name="supplementInst2"
                        component="div"
                        className="text-danger"
                      />
                    </td>
                  </tr>
                  {/* Row 4 */}
                  <tr>
                    <td>4</td>
                    <td>
                      Whether the Institute/ Society produced the SBTET order to
                      permit the backlog students of closing institute to appear
                      for the backlog exams from the recipient institute/s
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {RadioButtons("backlogExamInst1")}
                      <ErrorMessage
                        name="backlogExamInst1"
                        component="div"
                        className="text-danger"
                      />
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {RadioButtons("backlogExamInst2")}
                        <ErrorMessage
                        name="backlogExamInst2"
                        component="div"
                        className="text-danger"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

           {!recipientInstData ? (

  <div className="d-flex justify-content-end mt-3">
    <button type="submit" className="btn btn-primary">
      Submit
    </button>
  </div>

) : (

  <div className="d-flex justify-content-end mt-3">
    <span className="text-success fw-bold">
      Already Submitted
    </span>
  </div>

)}
            </>):( <div className="text-center text-danger fw-bold fs-6">
  **** No Data Found ****
</div>)}
          </Form>
        </FormikProvider>
      </div>
    </div>
  );
}
